// import createClient from "openapi-fetch";
// import {paths} from "../schema/api-schema";
// import {atom, computed} from "nanostores";
//
// const authToken = atom<string | undefined>(undefined);
//
// export const client = computed(authToken, (currentToken) =>
//   createClient<paths>({
//     headers: currentToken ? {Authorization: `Bearer ${currentToken}`} : {},
//     baseUrl: "https://stoplight.io/mocks/illio-rv/watchlist-project/173816703",
//   })
// );

export function getApiBase(environment: string) {
  if (!environment) throw new Error("Cross environment request detected.");
  switch (environment) {
    case "dev":
    case "stage":
    case "test":
      return `https://insight-widgets-${environment}.illio.com`;
    case "mock":
      return "https://stoplight.io/mocks/illio-rv/watchlist-project/173816703";
    case "prod":
      return "https://insight-widgets.illio.com";
  }
}

export function getConsumerApiBase(environment: string) {
  if (!environment) throw new Error("Cross environment request detected.");
  switch (environment) {
    case "dev":
    case "stage":
    case "test":
      return `https://${environment}.illio.com`;
    case "prod":
      return `https://wealth.illio.com`;
  }
}

export function getConsumerBaseUrl(environment: string) {
  if (window?.location?.href?.includes("localhost")) {
    return "http://localhost:3000";
  }
  if (!environment) throw new Error("Cross environment request detected.");

  switch (environment) {
    case "dev":
    case "stage":
    case "test":
      return `https://whatif-app-${environment}.illio.com`;
    case "prod":
      return `https://whatif-app-wealth.illio.com`;
  }
}
// client.get()
//   .get("/insight/insighttype/PERFORMANCE_VS_BENCHMARK", {params: {query: {instrumentid: 12}}}).then(res => {
//   const currency = res.data?.instrument?.ccy;
// })
